import api from "./baseApi";
import endpoints from "./endpoints";

// ================= GET PAGES =================

export const getPages = async (params = {}) => {
  try {
    const res = await api.get(endpoints.page.base, {
      params,
    });

    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to fetch pages";

    throw new Error(message);
  }
};

// ================= GET PAGE BY KEY =================

export const getPageByKey = async (pageKey) => {
  try {
    const res = await api.get(endpoints.page.detail(pageKey));

    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to fetch page";

    throw new Error(message);
  }
};

// ================= UPDATE PAGE =================

export const updatePage = async (pageKey, payload) => {
  try {
    const formData = new FormData();

    if (payload.id !== undefined) {
      formData.append("id", payload.id);
    }

    if (payload.version !== undefined) {
      formData.append("version", payload.version);
    }

    if (payload.title !== undefined) {
      formData.append("title", payload.title || "");
    }

    if (payload.content !== undefined) {
      formData.append("content", JSON.stringify(payload.content || {}));
    }

    if (payload.metaTitle !== undefined) {
      formData.append("metaTitle", payload.metaTitle || "");
    }

    if (payload.metaDescription !== undefined) {
      formData.append("metaDescription", payload.metaDescription || "");
    }

    if (payload.status !== undefined) {
      formData.append("status", payload.status || "draft");
    }

    if (payload.isPublished !== undefined) {
      formData.append("isPublished", payload.isPublished ? "1" : "0");
    }

    if (payload.createDraft !== undefined) {
      formData.append("createDraft", payload.createDraft ? "1" : "0");
    }

    if (payload.publish !== undefined) {
      formData.append("publish", payload.publish ? "1" : "0");
    }

    if (payload.files && typeof payload.files === "object") {
      Object.entries(payload.files).forEach(([field, file]) => {
        if (file) {
          formData.append("image", file);
        }
      });
    }

    const res = await api.put(endpoints.page.detail(pageKey), formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to update page";

    throw new Error(message);
  }
};

// ================= UPLOAD PAGE IMAGE =================

export const uploadPageImage = async (file, folder = "page") => {
  try {
    const formData = new FormData();

    formData.append("image", file);
    formData.append("folder", folder);

    const res = await api.post(endpoints.page.upload, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to upload page image";

    throw new Error(message);
  }
};